export class TypeComplaint{

     id: number;
	 name: string;
	 abbreviation: string;
     observation: string;
     
     constructor(){}
}

export class TypeComplaintForm{

    id: number;
    name: string;
    abbreviation: string;
    observation: string;
    
    constructor(){}
}
